compiler('[confirmation-modal-wizard]', (element) => {
  const possibleSteps = parseInt(element.getAttribute("data-confirmation-possible-steps"))
  let stepCount = 0
  let currentStep = 0
  let modalContents = {}
  let modalTitles = {}
  const DATA_CONFIRMED_ATTRIBUTE = 'data-modal-confirmed'
  // The data confirmed attribute is set, read and removed by this compiler itself
  // The persisted confirmed attribute will stay set on the element after confirmation for other components to be able to also receive that information
  const DATA_CONFIRMED_PERSISTED_ATTRIBUTE = 'data-modal-confirmed-persisted'

  for (let i = 0; i < possibleSteps; i++) {
    let title = element.getAttribute(`data-confirmation-step-${i}-title`)
    let content = element.getAttribute(`data-confirmation-step-${i}-content`)

    if (isPresent(title) && isPresent(content)) {
      modalContents[stepCount] = content
      modalTitles[stepCount] = title
      stepCount++
    }
  }

  if (!isPresent(modalContents[currentStep])) {
    return
  }

  element.addEventListener('click', (event) => {
    if(element.hasAttribute(DATA_CONFIRMED_ATTRIBUTE)) {
      element.removeAttribute(DATA_CONFIRMED_ATTRIBUTE)
      return
    }

    event.preventDefault()
    event.stopPropagation()

    const modal = DynamicModal.openModal(modalContents[currentStep], false, { default_title: modalTitles[currentStep] })
    setupModal(modal)
  })

  function setupModal(modal) {
    const acceptButton = modal.querySelector("[accept-confirmation]")
    const dismissButton = modal.querySelector("[dismiss-confirmation]")

    acceptButton.addEventListener('click', (event) => {
      bootstrap.Modal.getOrCreateInstance(modal).hide();

      if (nextStepValid()) {
        currentStep++
        const modal = openCurrentModal()
        setupModal(modal)
      } else {
        resetCurrentStep()
        element.setAttribute(DATA_CONFIRMED_ATTRIBUTE, "true")
        element.setAttribute(DATA_CONFIRMED_PERSISTED_ATTRIBUTE, "true")
        element.click()
      }
    })

    dismissButton.addEventListener('click', (event) => {
      resetCurrentStep()
      bootstrap.Modal.getOrCreateInstance(modal).hide();
    })
  }

  function openCurrentModal() {
    return DynamicModal.openModal(modalContents[currentStep], false, { default_title: modalTitles[currentStep] })
  }

  function nextStepValid() {
    return currentStep + 1 < stepCount
  }

  function isPresent(value) {
    return !(value === null || typeof value === 'undefined' || value === "")
  }

  function resetCurrentStep() {
    currentStep = 0
  }

})
